import { createAction, props } from '@ngrx/store';

import { NEWS_LIST_ROW_COUNT } from '../../constants';
import { NEWS_LIST_ACTIONS } from '../news-list-actions.type';

export const newsPageResizeAction = createAction(
  NEWS_LIST_ACTIONS.NEWS_PAGE_RESIZE,
  props<{
    rowCount: NEWS_LIST_ROW_COUNT;
  }>(),
);
